module.exports = __webpack_public_path__ + "img/HOS-Incomplete2.a6417bb9.png";